/* eslint-disable @typescript-eslint/no-explicit-any */
import { CrmAccessToken, OneGamingCrmErrorType } from "../models";

let _getAccessToken: () => Promise<CrmAccessToken>;
let _getCrmApiUrl: () => Promise<string>;
let _logEvent: (eventName: string, eventBody: Record<string, string>) => void;
let _logServerError: (message: string, type: OneGamingCrmErrorType, error?: any) => void;

export const setupOneGamingCrm = (
  getAccessToken: () => Promise<CrmAccessToken>,
  getCrmApiUrl: () => Promise<string>,
  logEvent?: (eventName: string, eventBody: Record<string, string>) => void,
  logServerError?: (message: string, type: OneGamingCrmErrorType, error?: any) => void
) => {
  _getAccessToken = getAccessToken;
  _getCrmApiUrl = getCrmApiUrl;
  if (logEvent) {
    _logEvent = logEvent;
  }
  if (logServerError) {
    _logServerError = logServerError;
  }
};

export const getAccessToken = async (): Promise<CrmAccessToken> => {
  if (!_getAccessToken) {
    throw new Error("OneGaming CRM is not configured. Please call setupOneGamingCrmConfig first.");
  }
  const accessToken = await _getAccessToken();
  return accessToken;
};

export const getCrmApiUrl = async (): Promise<string> => {
  if (!_getCrmApiUrl) {
    throw new Error("OneGaming CRM is not configured. Please call setupOneGamingCrmConfig first.");
  }
  const crmApiUrl = await _getCrmApiUrl();
  return crmApiUrl;
};

export const logEvent = (eventName: string, eventBody: Record<string, string>) => {
  if (_logEvent) {
    _logEvent(eventName, eventBody);
  }
};

export const logServerError = (message: string, type: OneGamingCrmErrorType, error?: any) => {
  if (_logServerError) {
    _logServerError(message, type, error);
  }
};
